import React from 'react';
import { Header } from './modules/HeaderContent';
import { Footer } from './modules/FooterContent';
import NeedMoreSupport from './modules/NeedMoreSupport';
import BreadCrumb from './modules/BreadCrumb';
import {Accordion, AccordionHeader, AccordionTitle, AccordionSubTitle, AccordionDetail, AccordionItem} from '@vds/accordions';
import SOHelpSection from './modules/ServiceOutageHelpSection';
import NetworkOutage from '../components/modules/NetworkOutage';
import { SIT_SERVER, MAIN_SERVER } from '../constants/constants';
import { Chat } from './modules/IncludeChat';
import ReactHtmlParser from 'react-html-parser';
import '../assets/css/serviceoutagestatus.css';
import '../assets/css/outage.css';
import { RTCICall } from "./modules/RTCICall";
import ErrorBoundary from './modules/ErrorHandler';
import { SiteCatalyst } from '../components/modules/SiteCatalyst';
import { isNullOrUndefined, RemoveHeaderHiddenClass } from './modules/CommonFunctions';
import { setNativeTitleWithNavigation, nativeHideTopBar, nativeUpdateFab, nativeSmartLinkToExternalBrowser } from "../actions/native";
import AlertBanner from './modules/AlertBanner';
const HeadingUnderline = {
    "text-decoration": "underline"
}
const SubHeadingdiv = {
    "width": "55%"
}
class ServiceOutage extends React.Component {

    constructor(props) {
        super(props);
        this.tabRef = React.createRef();
        this.contentRef = React.createRef();
        this.IsOneApp = false;
        if (window.oneAppFlag == true && window.oneAppFlag != null) {
            this.IsOneApp = "";
            this.IsOneApp = true;
        }
    }
    toggleTab(e) {
        let tabItem = e.target;
        if (tabItem.classList.contains('tabs_tab') && !tabItem.classList.contains('active')) {

            let currentlySelectedItem = tabItem.parentElement.querySelector('.active');
            let currentlySelectedItemIndex = parseInt(currentlySelectedItem.getAttribute('data-item-index'), 10);
            let newlySelectedItemIndex = parseInt(tabItem.getAttribute('data-item-index'), 10);

            let tabContentElements = document.querySelectorAll('.tab-content .panel')
            currentlySelectedItem.classList.remove('active');
            tabContentElements[currentlySelectedItemIndex].setAttribute('aria-hidden', true);
            tabContentElements[currentlySelectedItemIndex].setAttribute('tabIndex', -1);

            currentlySelectedItem.setAttribute('aria-selected', false);
            tabItem.setAttribute('aria-selected', true);
            tabItem.setAttribute('tabIndex', 0);
            tabItem.classList.add('active');

            let tabContent = tabContentElements[parseInt(newlySelectedItemIndex)];
            tabContent.setAttribute('aria-hidden', false);
            tabContent.classList.add('active');
            tabContent.setAttribute('style', 'display: block;');

            let prevSelectedContent = tabContentElements[currentlySelectedItemIndex];
            prevSelectedContent.setAttribute('aria-hidden', false);
            prevSelectedContent.classList.remove('active');
            prevSelectedContent.setAttribute('style', 'display: none;');


        }
        // let tablist = this.tabRef.current.querySelectorAll('.tabs_tab');??
        // for( var i=0;i < tablist.length; i++){
        //     let tabariaselected = tablist[i].getAttribute("aria-selected");
        //     let tabtabindex = tablist[i].getAttribute("tabIndex");
        //     if(tabariaselected === 'false' && tabtabindex === '0'){
        //         tablist[i].setAttribute('tabIndex', -1);
        //     }
        // }

    }

    changetabOnKeyPress(e) {
        if (e.target.classList.contains('m_article-tabs') || e.target.classList.contains('tabs_tab')) {
            let tabSelected; let tabSelectedIndex;
            let currentFocusedTabIndex = parseInt(this.tabRef.current.querySelector('.tabs_tab.active').getAttribute('data-item-index'), 10);
            let tablist = this.tabRef.current.querySelectorAll('.tabs_tab');
            for (var i = 0; i < tablist.length; i++) {
                let tabariaselected = tablist[i].getAttribute("data-item-tabselected");
                tabSelectedIndex = parseInt(tablist[i].getAttribute('data-item-index'), 10);
                let SelectedTab = this.tabRef.current.querySelectorAll('.tabs_tab')[tabSelectedIndex];
                if (tabariaselected == "true") {
                    currentFocusedTabIndex = tabSelectedIndex;
                    //  SelectedTab.setAttribute('aria-selected', true);
                    console.log("SelectTrue :" + tabSelectedIndex + "CurrentFocuse :" + currentFocusedTabIndex);
                } else {
                    // SelectedTab.setAttribute('aria-selected', false);
                    console.log("SelectFalse :" + tabSelectedIndex + "CurrentFocuse :" + currentFocusedTabIndex);
                }
            }

            if (e.keyCode === 39 || e.keyCode === 40) {
                let prevTab = this.tabRef.current.querySelectorAll('.tabs_tab')[currentFocusedTabIndex];
                let nextTab = (!isNullOrUndefined(this.tabRef.current.querySelectorAll('.tabs_tab')[currentFocusedTabIndex + 1])) ?
                    this.tabRef.current.querySelectorAll('.tabs_tab')[currentFocusedTabIndex + 1] : this.tabRef.current.querySelectorAll('.tabs_tab')[0];
                let prevContent = this.contentRef.current.querySelectorAll('.panel')[currentFocusedTabIndex];
                let nextContent = (!isNullOrUndefined(this.contentRef.current.querySelectorAll('.panel')[currentFocusedTabIndex + 1])) ?
                    this.contentRef.current.querySelectorAll('.panel')[currentFocusedTabIndex + 1] : this.contentRef.current.querySelectorAll('.panel')[0];
                if (!isNullOrUndefined(nextTab)) {
                    // prevTab.classList.remove('active');
                    //  prevContent.classList.remove('active');
                    //prevContent.setAttribute('aria-hidden', true);
                    //   prevTab.setAttribute('aria-selected', false);
                    prevTab.setAttribute('tabIndex', -1);
                    prevTab.classList.remove('tabSelected');
                    prevTab.setAttribute('data-item-tabselected', false);
                    //  prevContent.setAttribute('aria-hidden', true);
                    //  prevContent.setAttribute('aria-selected', false);                   
                    //nextTab.classList.add('active');
                    nextTab.classList.add('tabSelected');
                    // nextContent.classList.add('active');
                    nextTab.setAttribute('aria-hidden', false);
                    //nextTab.setAttribute('aria-selected', true);
                    nextTab.setAttribute('data-item-tabselected', true);
                    nextTab.setAttribute('tabIndex', 0);
                    //  nextContent.setAttribute('aria-selected', true);
                    // nextContent.setAttribute('aria-hidden', false);
                    nextTab.focus();
                    nextTab.classList.add('keyboard_focus');
                }
            }
            if (e.keyCode === 38 || e.keyCode === 37) {
                let totalTabs = this.tabRef.current.querySelectorAll('.tabs_tab').length - 1;
                let prevTab = this.tabRef.current.querySelectorAll('.tabs_tab')[currentFocusedTabIndex];
                let nextTab = (!isNullOrUndefined(this.tabRef.current.querySelectorAll('.tabs_tab')[currentFocusedTabIndex - 1])) ?
                    this.tabRef.current.querySelectorAll('.tabs_tab')[currentFocusedTabIndex - 1] : this.tabRef.current.querySelectorAll('.tabs_tab')[totalTabs];
                let prevContent = this.contentRef.current.querySelectorAll('.panel')[currentFocusedTabIndex];
                let nextContent = (!isNullOrUndefined(this.contentRef.current.querySelectorAll('.panel')[currentFocusedTabIndex - 1])) ?
                    this.contentRef.current.querySelectorAll('.panel')[currentFocusedTabIndex - 1] : this.contentRef.current.querySelectorAll('.panel')[totalTabs];
                if (!isNullOrUndefined(nextTab)) {
                    //  prevTab.classList.remove('active');
                    // prevTab.setAttribute('aria-hidden', true);
                    // prevTab.setAttribute('aria-selected', false);
                    prevTab.setAttribute('tabIndex', -1);
                    prevTab.classList.remove('tabSelected');
                    prevTab.setAttribute('data-item-tabselected', false);
                    //   prevContent.classList.remove('active');
                    //  prevContent.setAttribute('aria-hidden', true);
                    //  prevContent.setAttribute('aria-selected', false);
                    //nextTab.classList.add('active');
                    //   nextContent.classList.add('active');
                    nextTab.setAttribute('aria-hidden', false);
                    // nextTab.setAttribute('aria-selected', true);
                    nextTab.setAttribute('data-item-tabselected', true);
                    nextTab.classList.add('tabSelected');
                    nextTab.setAttribute('tabIndex', 0);
                    nextTab.focus();
                    // nextContent.setAttribute('aria-selected', true);
                    // nextContent.setAttribute('aria-hidden', false);
                    nextTab.classList.add('keyboard_focus');

                }
            }
            if (e.keyCode === 13) {

                let tablist = this.tabRef.current.querySelectorAll('.tabs_tab');
                for (var i = 0; i < tablist.length; i++) {
                    tablist[i].classList.remove('active');
                    tablist[i].setAttribute('aria-selected', false);
                }

                let totalTabs = this.tabRef.current.querySelectorAll('.tabs_tab').length - 1;
                let needtoShowContent = this.contentRef.current.querySelectorAll('.panel')[currentFocusedTabIndex];
                let hideContent = this.contentRef.current.querySelector('.panel');
                let activeContent = needtoShowContent.getAttribute('data-panelcontent-index');
                let tabContentElements = document.querySelectorAll('.tab-content .panel');
                let tabSelectAct = this.tabRef.current.querySelectorAll('.tabs_tab')[currentFocusedTabIndex];

                hideContent.classList.remove('active');
                hideContent.setAttribute('style', 'display: none;');
                hideContent.setAttribute('aria-selected', false);
                hideContent.setAttribute('aria-hidden', true);

                // needtoShowContent.classList.add('active');
                //let tabContent = parseInt(this.tabRef.current.querySelector('.tabs_tab.active').getAttribute('data-item-index'), 10);

                let divdata;
                for (var k = 0; k < this.contentRef.current.querySelectorAll('.panel').length; k++) {
                    divdata = this.contentRef.current.querySelectorAll('.panel')[k];
                    let panelindex = divdata.getAttribute('data-panelcontent-index');
                    if (currentFocusedTabIndex == panelindex) {
                        divdata.setAttribute('style', 'display: block;');
                    } else {
                        divdata.setAttribute('style', 'display: none;');

                    }
                }
                tabSelectAct.classList.add('active');
                tabSelectAct.setAttribute('aria-selected', true);
                needtoShowContent.setAttribute('aria-hidden', false);
                needtoShowContent.setAttribute('aria-selected', true);
                console.log(needtoShowContent);

            }
        }

    }

    getSignInUrl() {
        // let currentLocation = window.location.href;
        // let url = (currentLocation.indexOf('sit') > -1) ? SIT_SERVER : MAIN_SERVER;
        // return url + "home/myverizon/?goto=" + window.encodeURIComponent(currentLocation);
        let currentLocation = window.location.href;
        let url = currentLocation.indexOf("sit") > -1 ? SIT_SERVER : MAIN_SERVER;
        // window.location.href =
        //   url +
        //   "home/myverizon/?goto=" +
        //   window.encodeURIComponent(currentLocation);

        if (currentLocation.indexOf("sit") > -1) {
            return url = "https://securesit1.verizon.com/signin?goto=" +
                window.encodeURIComponent(currentLocation);
        }
        else if (currentLocation.indexOf("www98") > -1) {
            return url = "https://secure.verizon.com/signin?goto=" +
                window.encodeURIComponent(currentLocation);
        } else {
            return url = "https://secure.verizon.com/signin?goto=" +
                window.encodeURIComponent(currentLocation);
        }
    }

    convertTo12HourFormat(time) {
        let meridianTime = "";
        if (time !== "" && parseFloat(time.substring(0, time.indexOf(":"))) < 12) {
            meridianTime = time.substring(0, time.indexOf(":")) + time.substring(time.indexOf(":")) + " AM"
        } else if (time !== "") {
            let PMtime = (parseFloat(time.substring(0, time.indexOf(":"))) - 12 === 0) ? "12" : (parseFloat(time.substring(0, time.indexOf(":"))) - 12);
            meridianTime = (PMtime + time.substring(time.indexOf(":"))) + " PM"
        }
        return meridianTime;
    }

    convertEDTZoneTime(time) {
        if (time !== null && time !== undefined) {
            let months = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
            let splitTime = time.split('-');
            let splittedMonth = splitTime[1].toLowerCase();
            let restorationTime = months.map((item, index) => {
                if (months[index].indexOf(splittedMonth) > -1) {
                    const EDTTime = item.toUpperCase() + " " + splitTime[0] + ", " + "20" + splitTime[2].substring(0, splitTime[2].indexOf(" ")) + " " + this.convertTo12HourFormat(splitTime[2].substring(splitTime[2].indexOf(" ") + 1, splitTime[2].lastIndexOf(":"))) + " EDT";
                    return EDTTime;
                }
            })
            return restorationTime;
        }
    }

    validateMobileNumber(e) {
        this.validate(e.target);
    }

    validate(input) {
        let errElement = document.getElementById("ErrTxt");
        if (input.value.length < 10) {
            errElement.innerText = "Please enter valid 10 digit mobile number";
            errElement.classList.add('validated');
        } else {
            document.getElementById("ErrTxt").innerText = "";
            errElement.classList.remove('validated');
        }
    }

    validateOnKeyDown(e) {
        if (e.target.value.length >= 10) {
            document.getElementById("ErrTxt").classList.remove('validated');
            return false;
        }
    }

    submitOutageIssue() {
        const input = document.getElementById('userenteredMTN');
        this.validate(input);
        if (!document.getElementById('ErrTxt').classList.contains('validated')) {
            const notificationContent = "<div class='row large-padding-vert-zero hide' id='div2' style='display: block;'><div className='first_content tiny-12 small-12 medium-12 large-12 columns padding-bottom-small' style='padding-left:0.5625rem;padding-bottom:0.5625rem;'><div className='outage-alert-header bold' style='font-size:24px;line-height:27px;font-weight:bold'>You are being notified.</div><div>Updates on outages are being sent to your mobile.</div></div>" +
                "<div class='tiny-12 small-12 medium-12 large-12 columns'><div class='outage-border padding-top-tiny'><div class='text-large bold padding-top-tiny'>" +
                "<div class='display-table'><div class='display-table-cell'><span class='tick-icon icon-check small middle padding-right-tiny'></span></div><div class='display-table-cell' id='thankyoucontent'>" +
                "<font color='red'>Your notification request is unable to be processed at this time, we are however working to resolve your outage as quickly as possible. You may <a href='/support/consumer/contactus' style='color:#0066CC' name='&amp;lid=Otg_tq_contactus' id='outagecontactus' data-track='Contact Us'>Contact Us</a> to submit your request</font></div></div></div></div></div></div>";
            document.getElementsByClassName('notification_section')[0].innerHTML = notificationContent;
        }
    }

    componentDidMount() {
        if (window.oneAppFlag == true && window.oneAppFlag != null) {
            nativeHideTopBar(true);
        }
        let args = {
            intentCategory: "NBA_DISPLAY",
            activityCategory: "NBA_DISPLAY",
            intent: "",
            app_n_channel: "NBA-ESUPPORT",
            os: ""
        };
       // RTCICall(args);
        Chat();
        RemoveHeaderHiddenClass();
        // setTimeout(() => {
        // 	document.querySelector('.vzw-header').classList.remove('vzw-header');
        // }, 1000);
    }

    render() {
        // let isSignInUser = (document.cookie.indexOf('userinfo') > -1) ? true : false;
        let isSignInUser = false;
        if (window.userinfo !== null && window.userinfo !== undefined) { isSignInUser = true; }
        if (!isSignInUser) {

            return (
                <React.Fragment>
                    <ErrorBoundary>
                        <Header />
                    </ErrorBoundary>
                    <main role="main" className="outage signout">
                    <ErrorBoundary>
                            {
                                !this.IsOneApp && <BreadCrumb Content1="Support" Content2="Service Outage Information" />
                            }
                        </ErrorBoundary>
                        <ErrorBoundary>
                            {
                                !this.IsOneApp &&
                                <div className="row">
                                    <AlertBanner
                                        AlertBannerData={this.props.AlertBanner}
                                        isBreadCrumb={true}
                                    />
                                </div>
                            }
                        </ErrorBoundary>
                        {/* Common outage details */}
                        <section className="main bg-white large-mw-none" role="region">
                            <div className="row">
                                <div className="column tiny-12 ">
                                    <div>
                                        <h1 className="h2 margin-bottom-xlarge">{this.props.OutageData.titledesc[0].title}</h1>
                                        <div className="text-black padding-bottom-small">

                                            <p className="margin-bottom-zero" dangerouslySetInnerHTML={{ __html: this.props.OutageData.titledesc[0].richText2 }}></p>

                                            {/* <p>
                                                If you believe your service has been impacted by weather related issues resulting in a power outage or are only experiencing issues with your Verizon services, please see below for more information on tips to resolve.</p>
                                            <p>
                                                If you are looking to check the status of an existing repair request or are looking to update your request please visit <a href="/ForYourHome/VzRepair/FlowEngine/UFDService.aspx?Keyword=Web_TroubleTicket" tabIndex="0" data-track="CheckStatus">verizon.com/CheckStatus</a>.</p> */}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* Signin section*/}
                        <section className="main bg-grey-6 large-mw-none" role="region">
                            <div className="row text-black">
                                <div className="column tiny-12">
                                    <div className="all-services-header">
                                        <div className="all-services-content vert-top padding-left-small padding-top-tiny">
                                            <h2 style={HeadingUnderline}>Did you know?</h2>
                                            <div className="padding-bottom-tiny">
                                                You can sign in to check for outages that may be affecting your services. Should there be a service outage, we’ll provide you with a ticket number and estimated time of repair completion.<br />
                                                <a className="scbsignin  button cta-text mw-large" target="_self" href={this.getSignInUrl()} id="scbressignin" name="&amp;lid=//ghdr//signinreg" role="button" tabIndex="0">Sign In</a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* Power outage sections */}
                        <section className="padding-top-zero medium-padding-vert-large tiny-padding-vert-tiny power-outage" role="region">
                            <div className="row">
                                <div className="column tiny-12 padding-horiz-tiny">
                                    <h2 className="outage-sub-heading">{this.props.OutageData.titledesc[1].title}</h2>
                                    <p className="margin-bottom-zero" dangerouslySetInnerHTML={{ __html: this.props.OutageData.titledesc[1].richText2 }}></p>
                                </div>
                            </div>
                            <ErrorBoundary>
                            <div class="row">
                                <div class="tiny-12">
                                    <div className="accordian-wrap">
                                        <Accordion>
                                            {this.props.OutageData.accordions[0].accordionList.map(item => (
                                                item.accordionrte && <AccordionItem>
                                                <AccordionHeader 
                                                triggerType="icon"
                                                >      <AccordionTitle><span className="accordian-title">{item.accordianHeading}</span></AccordionTitle>
                                                </AccordionHeader>
                                                <AccordionDetail>
                                                {ReactHtmlParser(item.accordionrte)}
                                                </AccordionDetail>
                                            </AccordionItem>))}
                                        </Accordion>
                                    </div>
                                </div>
                            </div>
                            {/* <AccordianOld HeaderClass="hide_header" Header="" DataSource={this.props.OutageData.accordions[0].accordionList}></AccordianOld> */}
                            </ErrorBoundary>
                        </section>
                        {/* Tab section */}
                        <section className="padding-top-zero medium-padding-vert-large tiny-padding-vert-tiny">
                            <div className="row" key="tab">
                                <div className="column tiny-12 padding-horiz-tiny">
                                    <h2 className="outage-sub-heading">{this.props.OutageData.titledesc[2].title}</h2>
                                    <p className="margin-bottom-zero" dangerouslySetInnerHTML={{ __html: this.props.OutageData.titledesc[2].richText2 }}></p>
                                </div>
                                <ul data-horizscroll key="tabs" ref={this.tabRef} className="w_tabs m_margin m_article-tabs m_category-tabs " role="tablist" onKeyDown={this.changetabOnKeyPress.bind(this)}>
                                    {
                                        this.props.OutageData.tablist[0].tablist.map((item, index) => {
                                            return <li key={"tab" + index} id={item.tabId} className={(index === 0) ? "tabs_tab padding-bottom-small active" : "tabs_tab padding-bottom-small"}
                                                aria-selected={(index === 0) ? "true" : "false"} role="tab" tabIndex={(index === 0) ? "0" : "-1"} data-item-index={index} data-item-tabselected={(index === 0) ? "true" : "false"} onClick={this.toggleTab.bind(this)} aria-label={item.tabHeading}  >{item.tabHeading}</li>
                                        })
                                    }
                                </ul>
                                <div className="padding-bottom-medium tab-content-wrapper tab-content" ref={this.contentRef}>
                                    {
                                        this.props.OutageData.tablist[0].tablist.map((item, index) => {
                                            return <React.Fragment key={"tab" + index}>
                                                <div className={(index === 0) ? "panel bg-white margin-bottom-zero active" : "panel bg-white margin-bottom-zero"} data-panelcontent-index={index}>
                                                    <div className={(index === 3) ? "last-tab row" : "row"}>
                                                        <div className="columns tiny-12" >

                                                            {/* Common for all tabs */}
                                                            {ReactHtmlParser(item.tdlist[0].richText2)}

                                                            {/* Third Tab */}
                                                            {index === 2 ? ReactHtmlParser("<a class='button cta-text mw-large' role='button' target='_self' data-track='Sign In' href=" + this.getSignInUrl() + ">Sign In</a>") : ""}

                                                            {/* Second Tab */}
                                                            {(index === 1) ? ReactHtmlParser("<a class='button cta-text mw-large focusAdd' role='button' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_BATT' data-track='Reset Now'>Reset Now</a>") : ""}
                                                            {((index === 1) && item.tdlist[1] !== undefined) ? ReactHtmlParser(item.tdlist[1].richText2) : ""}

                                                            {/* Fourth Tab */}
                                                            {index === 3 ? ReactHtmlParser("<a class='button cta-text mw-large' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_ASO' role='button' data-track='Fix all services out'>Fix all services out</a>") : ""}
                                                            {index === 3 ? ReactHtmlParser("<a class='button cta-text mw-large' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_STBRemotes' role='button' data-track='Fix set-top box or remote'>Fix Set-Top Box or Remote</a>") : ""}
                                                            {index === 3 ? ReactHtmlParser("<a class='button cta-text mw-large' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_ACO' role='button' data-track='Fix all TV channels out'>Fix all TV channels out</a>") : ""}
                                                            {index === 3 ? ReactHtmlParser("<a class='button cta-text mw-large' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_NDT' role='button' data-track='Fix no dial tone'>Fix no dial tone</a>") : ""}
                                                            {item.accordionDataList && <div class="row">
                                                                <div class="tiny-12">
                                                                    <div className="accordian-wrap">
                                                                        <Accordion>
                                                                            {item.accordionDataList[0].accordionList.map(item => (
                                                                                item.accordionrte && <AccordionItem>
                                                                                <AccordionHeader 
                                                                                triggerType="icon"
                                                                                >      <AccordionTitle><span className="accordian-title">{item.accordianHeading}</span></AccordionTitle>
                                                                                </AccordionHeader>
                                                                                <AccordionDetail>
                                                                                {ReactHtmlParser(item.accordionrte)}
                                                                                </AccordionDetail>
                                                                            </AccordionItem>))}
                                                                        </Accordion>
                                                                    </div>
                                                                </div>
                                                            </div>}
                                                            {/* <AccordianOld Header="" HeaderClass="hide" DataSource={(item.accordionDataList !== undefined) ? item.accordionDataList[0].accordionList : []}></AccordianOld> */}
                                                            <div className="row">
                                                                <div className="column tiny-12 padding-horiz-tiny">
                                                                    {(index === 0 && item.tdlist[1] !== undefined) ? ReactHtmlParser(item.tdlist[1].richText2) : ""}
                                                                    {(index === 0) ? ReactHtmlParser("<a class='button cta-text mw-large focusAdd' target='_blank' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_CCON' role='button' data-track='Fix Connection Issues'>Fix Connection Issues</a>") : ""}
                                                                    {(item.tdlist[2] !== undefined) ? ReactHtmlParser(item.tdlist[2].richText2) : ""}
                                                                    {(index === 0) ? ReactHtmlParser("<a class='button cta-text mw-large focusAdd' target='_blank' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_ASO' role='button' data-track='Fix Service'>Fix Service</a>") : ""}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        })
                                    }
                                </div>
                            </div>
                        </section>
                        <ErrorBoundary>
                            <SOHelpSection />
                        </ErrorBoundary>

                        <ErrorBoundary>
                        <div class="row">
                            <div class="tiny-12">
                                <div className="accordian-wrap">
                                    <Accordion>
                                        <h2 className="text-underline">Frequently Asked Questions</h2>
                                        {this.props.OutageData.accordions[1].accordionList  .map(item => (
                                            item.accordionrte && <AccordionItem>
                                            <AccordionHeader 
                                            triggerType="icon"
                                            >      <AccordionTitle><span className="accordian-title">{item.accordianHeading}</span></AccordionTitle>
                                            </AccordionHeader>
                                            <AccordionDetail>
                                            {ReactHtmlParser(item.accordionrte)}
                                            </AccordionDetail>
                                        </AccordionItem>))}
                                    </Accordion>
                                </div>
                            </div>
                        </div>
                        {/* <AccordianOld Header="Frequently Asked Questions" DataSource={this.props.OutageData.accordions[1].accordionList}></AccordianOld> */}
                        </ErrorBoundary>

                        <section className="main large-mw-none medium-padding-vert-xlarge border-bottom tiny-padding-vert-zero" role="region">
                            <div className="row medium-padding-bottom-xlarge tiny-padding-bottom-medium padding-top-tiny padding_hide">
                                <div className="column tiny-12 ">
                                    <h2>
                                        {this.props.OutageData.titledesc[4].title}</h2>
                                    <div className="text-xlarge">
                                        {ReactHtmlParser(this.props.OutageData.titledesc[4].richText2)}</div>
                                </div>
                            </div>
                            <div className="row padding-horiz-tiny">
                                <div className="column tiny-12 medium-6 medium-border-right tiny-border-bottom partial_width" style={SubHeadingdiv}>
                                    <h3>
                                        {this.props.OutageData.collist[0].titleDescription[0].title}</h3>
                                    <div className="padding-bottom-large">
                                        {ReactHtmlParser(this.props.OutageData.collist[0].titleDescription[0].richText2)}</div>
                                    <a className="button outage-cta-btn cta-text padding-bottom-small" href="https://search.verizonwireless.com/onesearch/search?q=outage" role="button" tabindex="0" data-track='Learn More' aria-label={"Learn more " + this.props.OutageData.collist[0].titleDescription[0].title}>Learn more</a></div>
                                {/* <div className="column tiny-12 medium-6 medium-padding-top-zero tiny-padding-top-small medium-padding-left-small tiny-padding-left-micro partial_width">
                                    <div className="bold outage-list-subheading">
                                        {this.props.OutageData.collist[1].titleDescription[0].title}</div>
                                    <div className="padding-bottom-large">
                                        {ReactHtmlParser(this.props.OutageData.collist[1].titleDescription[0].richText2)}</div>
                                    <a className="button outage-cta-btn cta-text padding-bottom-small" href="https://www.verizon.com/Support/SmallBusiness/Internet/fiosinternet/general+support/top+questions/questionsone/130288.htm" role="button" tabindex="0" data-track='Learn More'>Learn more</a></div> */}
                            </div>
                        </section>

                        <ErrorBoundary>
                            <NeedMoreSupport Data={this.props.OutageData} />
                        </ErrorBoundary>

                    </main>
                    <ErrorBoundary>
                        <Footer />
                    </ErrorBoundary>
                    <input type="hidden" value={(isSignInUser) ? "Auth" : "UnAuth"} id="loginType" />
                    <ErrorBoundary>
                        <SiteCatalyst PageDetails={this.props.OutageData.pagedetails} />
                    </ErrorBoundary>
                </React.Fragment>
            )
        } else {
            return (
                <React.Fragment>
                    <ErrorBoundary>
                        <Header />
                    </ErrorBoundary>
                    <main role="main" className="outage">
                    <ErrorBoundary>
                            {
                                !this.IsOneApp && <BreadCrumb Content1="Support" Content2="Service Outage Information" />
                            }
                        </ErrorBoundary>
                        <ErrorBoundary>
                            {
                                !this.IsOneApp &&
                                <div className="row">
                                <AlertBanner
                                  AlertBannerData={this.props.AlertBanner}
                                  isBreadCrumb={true}
                                />
                              </div>
                            }
                        </ErrorBoundary>
                        <ErrorBoundary>
                            <NetworkOutage isOutagePresents={(this.props.OutageData.servicelist !== undefined && this.props.OutageData.servicelist !== null && this.props.OutageData.servicelist.length > 0) ? true : false} ConvertTime={this.convertEDTZoneTime.bind(this)} Outage={(this.props.DynamicData !== null && this.props.DynamicData !== undefined) ? this.props.DynamicData.resourcesummary : []}
                                NotificationItems={(this.props.OutageData.callmelist !== null && this.props.OutageData.callmelist !== undefined) ? this.props.OutageData.callmelist : []} OutageStaticData={this.props.OutageData.servicelist} KeyDownValidation={this.validateOnKeyDown.bind(this)} Validation={this.validateMobileNumber.bind(this)} Submit={this.submitOutageIssue.bind(this)}></NetworkOutage>
                        </ErrorBoundary>
                        {/* Power outage sections */}
                        <section className="padding-top-zero medium-padding-vert-large tiny-padding-vert-tiny power-outage" role="region">
                            <div className="row">
                                <div className="column tiny-12 padding-horiz-tiny">
                                    <h2 className="outage-sub-heading">{this.props.OutageData.titledesc[1].title}</h2>
                                    <p className="margin-bottom-zero" dangerouslySetInnerHTML={{ __html: this.props.OutageData.titledesc[1].richText2 }}></p>
                                </div>
                            </div>
                        <ErrorBoundary>
                            <div class="row">
                                <div class="tiny-12">
                                    <div className="accordian-wrap">
                                        <Accordion>
                                            {this.props.OutageData.accordions[0].accordionList.map(item => (
                                                item.accordionrte && <AccordionItem>
                                                <AccordionHeader 
                                                triggerType="icon"
                                                >      <AccordionTitle><span className="accordian-title">{item.accordianHeading}</span></AccordionTitle>
                                                </AccordionHeader>
                                                <AccordionDetail>
                                                {ReactHtmlParser(item.accordionrte)}
                                                </AccordionDetail>
                                            </AccordionItem>))}
                                        </Accordion>
                                    </div>
                                </div>
                            </div>
                            {/* <AccordianOld HeaderClass="hide_header" Header="" DataSource={this.props.OutageData.accordions[0].accordionList}></AccordianOld> */}
                        </ErrorBoundary>
                        </section>
                        {/* Tab section */}
                        <section className="padding-top-zero medium-padding-vert-large tiny-padding-vert-tiny">
                            <div className="row" key="tab">
                                <div className="column tiny-12 padding-horiz-tiny">
                                    <h2 className="outage-sub-heading">{this.props.OutageData.titledesc[2].title}</h2>
                                    <p className="margin-bottom-zero" dangerouslySetInnerHTML={{ __html: this.props.OutageData.titledesc[2].richText2 }}></p>
                                </div>
                                <ul data-horizscroll key="tabs" className="w_tabs m_margin m_article-tabs m_category-tabs" role="tablist" tabIndex="0" ref={this.tabRef} onKeyDown={this.changetabOnKeyPress.bind(this)}>
                                    {
                                        this.props.OutageData.tablist[0].tablist.map((item, index) => {
                                            return <li key={"tab" + index} id={item.tabId} className={(index === 0) ? "tabs_tab padding-bottom-small active" : "tabs_tab padding-bottom-small"}
                                                aria-selected={(index === 0) ? true : false} role="tab" tabIndex="-1" data-item-index={index} onClick={this.toggleTab.bind(this)} aria-label={item.tabHeading} >{item.tabHeading}</li>
                                        })
                                    }
                                </ul>
                                <div className="padding-bottom-medium tab-content-wrapper tab-content" ref={this.contentRef}>
                                    {
                                        this.props.OutageData.tablist[0].tablist.map((item, index) => {
                                            return <React.Fragment key={"tab" + index}>
                                                <div className={(index === 0) ? "panel bg-white margin-bottom-zero active" : "panel bg-white margin-bottom-zero"}>
                                                    <div className={(index === 3) ? "last-tab row" : "row"}>
                                                        <div className="columns tiny-12" >

                                                            {/* Common for all tabs */}
                                                            {ReactHtmlParser(item.tdlist[0].richText2)}

                                                            {/* Third Tab */}
                                                            {(!isSignInUser && index === 2) ? ReactHtmlParser("<a class='button cta-text mw-large' role='button' target='_self' href=" + this.getSignInUrl() + ">Sign In</a>") : ""}

                                                            {/* Second Tab */}
                                                            {(index === 1) ? ReactHtmlParser("<a class='button cta-text mw-large focusAdd' role='button' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_BATT' data-track='Reset Now'>Reset Now</a>") : ""}
                                                            {((index === 1) && item.tdlist[1] !== undefined) ? ReactHtmlParser(item.tdlist[1].richText2) : ""}

                                                            {/* Fourth Tab */}
                                                            {index === 3 ? ReactHtmlParser("<a class='button cta-text mw-large' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_ASO' role='button' data-track='Fix all services out'>Fix all services out</a>") : ""}
                                                            {index === 3 ? ReactHtmlParser("<a class='button cta-text mw-large' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_STBRemotes' role='button' data-track='Fix Set-Top Box or Remote'>Fix Set-Top Box or Remote</a>") : ""}
                                                            {index === 3 ? ReactHtmlParser("<a class='button cta-text mw-large' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_ACO' role='button' data-track='Fix all tv channels out'>Fix all TV channels out</a>") : ""}
                                                            {index === 3 ? ReactHtmlParser("<a class='button cta-text mw-large' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_NDT' role='button' data-track='Fix no dial tone'>Fix no dial tone</a>") : ""}
                                                            {item.accordionDataList && <div class="row">
                                                                <div class="tiny-12">
                                                                    <div className="accordian-wrap">
                                                                        <Accordion>
                                                                            {item.accordionDataList[0].accordionList.map(item => (
                                                                                item.accordionrte && <AccordionItem>
                                                                                <AccordionHeader 
                                                                                triggerType="icon"
                                                                                >      <AccordionTitle><span className="accordian-title">{item.accordianHeading}</span></AccordionTitle>
                                                                                </AccordionHeader>
                                                                                <AccordionDetail>
                                                                                {ReactHtmlParser(item.accordionrte)}
                                                                                </AccordionDetail>
                                                                            </AccordionItem>))}
                                                                        </Accordion>
                                                                    </div>
                                                                </div>
                                                            </div>}
                                                            {/* <AccordianOld Header="" HeaderClass="hide" DataSource={(item.accordionDataList !== undefined) ? item.accordionDataList[0].accordionList : []}></AccordianOld> */}
                                                            <div className="row">
                                                                <div className="column tiny-12 padding-horiz-tiny">
                                                                    {(index === 0 && item.tdlist[1] !== undefined) ? ReactHtmlParser(item.tdlist[1].richText2) : ""}
                                                                    {(index === 0) ? ReactHtmlParser("<a class='button cta-text mw-large focusAdd' target='_blank' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_CCON' role='button' data-track='Fix connection issues'>Fix Connection Issues</a>") : ""}
                                                                    {(item.tdlist[2] !== undefined) ? ReactHtmlParser(item.tdlist[2].richText2) : ""}
                                                                    {(index === 0) ? ReactHtmlParser("<a class='button cta-text mw-large focusAdd' target='_blank' href='https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDService.aspx?Keyword=FIX_ASO' role='button' data-track='Fix service'>Fix Service</a>") : ""}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        })
                                    }
                                </div>
                            </div>
                        </section>

                        <ErrorBoundary>
                            <SOHelpSection />
                        </ErrorBoundary>

                        <ErrorBoundary>
                        <div class="row">
                            <div class="tiny-12">
                                <div className="accordian-wrap">
                                    <Accordion>
                                        <h2 className="text-underline">Frequently Asked Questions</h2>
                                        {this.props.OutageData.accordions[1].accordionList.map(item => (
                                            item.accordionrte && <AccordionItem>
                                            <AccordionHeader 
                                            triggerType="icon"
                                            >      <AccordionTitle><span className="accordian-title">{item.accordianHeading}</span></AccordionTitle>
                                            </AccordionHeader>
                                            <AccordionDetail>
                                            {ReactHtmlParser(item.accordionrte)}
                                            </AccordionDetail>
                                        </AccordionItem>))}
                                    </Accordion>
                                </div>
                            </div>
                        </div>
                        {/* <AccordianOld Header="Frequently Asked Questions" DataSource={this.props.OutageData.accordions[1].accordionList}></AccordianOld> */}
                        </ErrorBoundary>

                        <ErrorBoundary>
                            <NeedMoreSupport Data={this.props.OutageData} />
                        </ErrorBoundary>
                    </main>
                    <ErrorBoundary>
                        <Footer />
                    </ErrorBoundary>
                    {/* <Footer FooterContent={this.props.FooterContent} /> */}
                    <input type="hidden" value={(isSignInUser) ? "Auth" : "UnAuth"} id="loginType" />
                    <ErrorBoundary>
                        <SiteCatalyst PageDetails={this.props.OutageData.pagedetails} />
                    </ErrorBoundary>
                </React.Fragment>
            )
        }
    }
}

export default ServiceOutage




// WEBPACK FOOTER //
// ./src/components/ServiceOutagePage.js